import React from 'react';
import { Link } from 'react-router-dom';
import ProjectionTeamSheet from '../../Projections/ProjectionTeamSheet/ProjectionTeamSheet';

export default function ProjectionTeamPage({
	get_projection_team_endpoint,
	update_projection_team_endpoint
}) {
	return (
		<div className="container p-4 lg:py-14 md:px-20">
			<div className="mb-4 flex justify-end">
				<Link
					to="/projections"
					className="text-sm font-medium text-blue-600 dark:text-blue-400 hover:underline"
				>
					← NFL Team Projections
				</Link>
			</div>
			<ProjectionTeamSheet
				get_projection_team_endpoint={get_projection_team_endpoint}
				update_projection_team_endpoint={update_projection_team_endpoint}
			/>
		</div>
	);
}
